export const oktaConfig = {
  issuer: import.meta.env.VITE_OKTA_ISSUER ?? "",
  clientId: import.meta.env.VITE_OKTA_CLIENT_ID ?? "",
  redirectUri: import.meta.env.VITE_OKTA_REDIRECT_URI ?? `${window.location.origin}/okta-callback`,
  scopes: import.meta.env.VITE_OKTA_SCOPES ?? "openid profile email",
} as const;
